/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Options_Cli_Configuration_TitleInputs */



/**
* | output |
* | --- |
* | "{name} Configuration" |
*
* @param {Options_Cli_Configuration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_configuration_title = /** @type {((inputs: Options_Cli_Configuration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Configuration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Configuration de ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} Konfiguration`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Configurazione ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Конфигурация ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Configuración de ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.name} 配置`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} 構成`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} कॉन्फ़िगरेशन`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Configuração ${i?.name}`)
	return /** @type {LocalizedString} */ (`${i?.name} Configuration`)
});